import { AuditoinnitCacheKeys } from '../cacheKeys';
import IAudit, { IAuditListFilters } from '../../interfaces/IAudit';
import { IPagination } from '../../interfaces/common/IPagination';
import { IAuditItem } from '../../interfaces/IAuditItem';
import AuditItemMapper from '../../mappers/AuditItemMapper';
import { useLocalStorage } from '../../../sg-hooks/useLocalStorage';
import { getAuditCountSearchParams, mostRecentDesktopPagination, mostRecentFilters, mostRecentMobilePagination } from '../../constants/controlledFiltters';
import { useSWRCache } from '../../../sg-core/swr/useSWRCache';
import { AUDIT_FILTERS } from '../../constants/StorageKeys';
import { useAuthContext } from '../../auth/AuthenticationProvider';


export const useAuditCache = () => {
    const { token, lang } = useAuthContext();
    const { trigger, mutate } = useSWRCache()

    const [storedFilters] = useLocalStorage<IAuditListFilters>(AUDIT_FILTERS, { roles: [] })

    const revalidateStaticLists = async () => {
        await trigger(AuditoinnitCacheKeys(token, lang).AuditPage(mostRecentDesktopPagination, mostRecentFilters), true);
        await trigger(AuditoinnitCacheKeys(token, lang).AuditPage(mostRecentMobilePagination, mostRecentFilters), true);
        await trigger(AuditoinnitCacheKeys(token, lang).AuditCounts(getAuditCountSearchParams(storedFilters)), true);
    };

    const revalidatePage = async (pagination: IPagination, filters: Partial<IAuditListFilters> = { roles: [] }) => {
        await trigger(AuditoinnitCacheKeys(token, lang).AuditPage(pagination, filters), true);
    };

    const recieveItems = async (items: IAuditItem[]) => {
        items.forEach((item) => {
            mutate(AuditoinnitCacheKeys(token, lang).AuditItemInstance(item.id), item);
        });
    };


    const mutateItemInstance = async (audit: IAudit) => {
        const item = AuditItemMapper.auditToItem(audit);
        await mutate(AuditoinnitCacheKeys(token, lang).AuditItemInstance(item.id), item);
    };

    const mutateInstance = async (audit: IAudit) => {

        await mutate(AuditoinnitCacheKeys(token, lang).AuditInstance(audit.guid), audit);
    };

    const clearInstance = async (audit: IAudit["guid"]) => {
        await mutate(AuditoinnitCacheKeys(token, lang).AuditInstance(audit), null)
    };


    return {
        recieveItems,
        mutateItemInstance,

        revalidateStaticLists,

        revalidatePage,

        mutateInstance,
        clearInstance
    };
};